// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "action",
                Decco.stringToJson(v.action)
              ],
              [
                "campaign_id",
                Decco.intToJson(v.campaign_id)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
